import React from 'react'

function TechSelectionVAZD() {
  return (
    <embed src="\pdfs\E1.5.1.1_VA-ZD_Circular_displacement_outlet-adjustable_damper_04.2018.pdf" width="100%" height="2100px" />
  )
}

export default TechSelectionVAZD